import React, { useEffect, useState } from 'react';
import AssignTagPicker from '@/components/AssignTagPicker';
import PageContent from '@/components/PageContent';
import { Loader } from 'rsuite';
import { City } from '@/models/city.model';
import { assignRunEventKeyToCity, getRunEventKeysLookup, unassignRunEventKeyFromCity } from '@/services/run-event-key.service';

interface CityRunEventKeyProps{
  parentCity?: City;
}

const CityRunEventKey: React.FC<CityRunEventKeyProps> = ({parentCity}) => {
  
  const [city, setCity] = useState<City|undefined>();
  
  useEffect(() => {
    setCity(parentCity);
  }, [parentCity]);
  
  if(!city){
    return(
      <Loader center content="loading ..." />
    );
  }
  return (
    <PageContent>
      <label>Run Event Keys:</label>
      <AssignTagPicker
        fetchData={(txt) => getRunEventKeysLookup(txt).then(res => res.data)}
        fetchAssignedItems={() => getRunEventKeysLookup(undefined, city.id, undefined).then(res => res.data.map(k => k.value)) }
        onAssign={ (itemId:number) => assignRunEventKeyToCity({ cityId: city.id, runEventKeyId: itemId }) }
        onUnAssign={ (itemId:number) => unassignRunEventKeyFromCity({ cityId: city.id, runEventKeyId: itemId }) }
        block
      />
    </PageContent>
  );

};

export default CityRunEventKey;
